<template>
  <div class="component-nav">
      <nav class="nav-pc container d-none d-md-block">
        <img src="../assets/logo.png" alt="logo" class="logo">
        <div class="nav-pc-nav">
            <router-link to="/">首页</router-link>
            <router-link to="/product">解决方案</router-link>
            <router-link to="/about">关于我们</router-link>
            <router-link to="/joinus" class="nav_end">加入我们</router-link>
            <div class="mini_project">
                <img :src="miniProject" class="min_project_img min_project_img1" alt="">
                <span class="min_project_word">营销赋能案例</span>
            </div>
            <div class="mini_project_sec">
                <img :src="miniProjectSec" class="min_project_img" alt="">
                <span class="min_project_word">扫码了解案例详情</span>
            </div>

            <div class="mini_project_btn">
                <div class="mini_project_top" @click="goDownLoadPage(1)">应用宝下载</div>
                <div class="mini_project_bot" @click="goDownLoadPage(2)">官网下载</div>
            </div>

            <div class="mini_relation" @click="goRelationPage">
                <div class="relation_info">观看视频</div>
                <div class="relation_icon"></div>
            </div>

            <!-- <openWeapp></openWeapp> -->
        </div>
    </nav>

    <nav class="nav-mob d-md-none">
        <div class="navbar-light">
            <span class="navbar-toggler-icon" @click="showNav"></span>
            <img src="../assets/logo.png" alt="logo" class="logo">
        </div>
        <transition name="slide-left">
            <div class="nav-mobile" v-show="open" @click="hideNav">
                <div class="wrapper">
                    <ul :class='["d-md-none list-unstyled"]'>
                        <li>
                            <router-link to="/">首页</router-link>
                        </li>
                        <li>
                            <router-link to="/product">解决方案</router-link>
                        </li>
                        <li>
                            <router-link to="/about">关于我们</router-link>
                        </li>
                        <li>
                            <router-link to="/joinus">加入我们</router-link>
                        </li>
                    </ul>
                </div>
                <div @click="hideNav" v-show="open" class="mask"></div>
            </div>
        </transition>
    </nav>
  </div>
</template>

<script>
import miniProject from '../assets/mini_project.png'
import miniProjectSec from '../assets/mini_project2.png'
import util from "../util/util.js";
// import openWeapp from "./openWeapp"
export default {
//   components: {
//       openWeapp
//   },
  data () {
    return {
      open: false,
      miniProject,
      miniProjectSec
    }
  },
  mounted(){
  },
  methods: {
    showNav () {
      document.querySelector('html').classList.toggle('oh')
      this.open = !this.open
    },
    hideNav () {
      document.querySelector('html').classList.toggle('oh')
      this.open = !this.open
    },
    goRelationPage(){
       util.goContact();
    },
    goDownLoadPage(type){
        if(type == 1){
            window.open("https://a.app.qq.com/o/simple.jsp?pkgname=com.thepixel.client.android")
        } else if(type == 2){
            window.open("https://apk.milinzone.com/milin.apk","_self")
        }
    }
  }
}
</script>

<style lang="scss">
    .oh {
        width: 100%;
        height: 100%;
        overflow: hidden;
        body {
            width: 100%;
            height: 100%;
            overflow: hidden;
        }
    }

    .nav-pc {
        width: 100%;
        max-width: 1100px;
        margin: 0 auto;
        text-align: right;
        font-size: 18px;
        line-height: 110px;
        // position: relative;
        .logo {
            float: left;
            margin-top: 22px;
        }
        .nav-pc-nav{
            width: 100%;
            position: relative;
            .nav_end{
                margin-right: 360px;
            }
            .mini_project{
                position: absolute;
                height: 122px;
                width: 100px;
                display: inline-block;
                right: 180px;
                top: 22px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: flex-start;
                .min_project_img{
                    height: 100px;
                    width: 100px;
                }
                .min_project_img1{
                    width: 100px;
                    height: 100px;;
                }
                .min_project_word{
                    height: 12px;;
                    font-size: 12px;
                    margin-top: 10px;
                    color: #121212;
                    line-height: 12px;
                    font-weight: 500;
                }
            }
            .mini_project_sec{
                position: absolute;
                height: 122px;
                width: 100px;
                display: inline-block;
                right: 60px;
                top: 22px;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: flex-start;
                .min_project_img{
                    height: 100px;
                    width: 100px;
                }
                .min_project_word{
                    height: 12px;;
                    font-size: 12px;
                    margin-top: 10px;
                    color: #121212;
                    line-height: 12px;
                    font-weight: 500;
                }
            }
            .mini_project_btn{
                position: absolute;
                height: 122px;
                width: 100px;
                right: -60px;
                top: 22px;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                .mini_project_top,.mini_project_bot{
                    width: 100px;
                    height: 40px;
                    background: #07C160;
                    font-size: 14px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 4px;
                    cursor: pointer;
                }
            }
            .mini_relation{
                width: 136px;
                height: 44px;
                border-radius: 7px;
                border: 1px solid #07C160;
                position: absolute;
                right: 0px;
                bottom: -115px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                z-index: 100;
                box-shadow: 0px 1px 18px 0px rgba(7, 193, 96, 0.19);
            }
            .relation_info{
                font-size: 18px;
                margin-right: 10px;
                line-height: 44px;
                font-weight: 500;
            }
            .relation_icon{
                width: 18px;
                height: 18px;
                background: url("../assets/jump_icon.png") center center;
                background-size: 100% 100%;
            }
        }
        a {
            padding: 10px 0;
            text-decoration: none;
            color: #333;
            margin-left: 40px;
            font-size: 18px;
            transition: all ease .3s;

            &:hover {
                text-decoration: none;
                color: #07C160;
            }
        }

        .router-link-exact-active {
            color: #07C160;
            border-bottom: 3px solid #07C160;
        }
    }

    .nav-mob {
        text-align: left;

        a {
            font-size: 18px;
            color: #fff;
            width: 100%;
            height: 100%;
            display: block;
        }

        .router-link-exact-active {
            color: #07C160;
        }

        .navbar-light {
            padding: 10px 10px 0 10px;
            text-align: center;
            overflow: hidden;
            position: relative;
            .navbar-toggler-icon {
               position: absolute;
               left: 10px;
               bottom: 0px
            }

            .logo {
                width: 2rem;
                height: 2rem;
            }
        }

        .nav-mobile {
            position: fixed;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: rgba(0,0,0,.8);
            z-index: 999;
        }

        li {
            padding-left: 1rem;
            border-bottom: 1px solid #666;
            line-height: 3;
        }
    }

    .slide-left-enter, .slide-left-leave-active {
            opacity: 0;
            transform: translateY(-10%);
        }
        .slide-left-enter-to, .slide-left-leave-active {
            transition: all .55s cubic-bezier(0.24, 0.43, 0.12, 0.72);
        }
</style>
